import { render, staticRenderFns } from "./AttributesDetailModal.vue?vue&type=template&id=baff9f64&scoped=true"
import script from "./AttributesDetailModal.vue?vue&type=script&lang=js"
export * from "./AttributesDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baff9f64",
  null
  
)

export default component.exports